import { vehicleTypesSlice } from "./vehicleTypesSlice";
import * as actions from "./vehicleTypesActions";
import * as selectors from "./vehicleTypesSelectors";

export { actions };
export { selectors };

export default vehicleTypesSlice.reducer;
